import { Routes } from '@angular/router';
import { GetCalculationComponent } from './pages/get-calculation/get-calculation.component';
import {
  Section84_1FormComponent,
} from './components/calculations/section-84_1/form/section-84_1-form/section-84_1-form.component';
import { CalculationFormEditingGuard } from './guards/calculation-form-editing.guard';
import {
  Section84_1ResultComponent,
} from './components/calculations/section-84_1/result/section-84_1-result/section-84_1-result.component';
import { CreateNewCalculationComponent } from './pages/create-new-calculation/create-new-calculation.component';
import { ListCalculationsComponent } from './pages/list-calculations/list-calculations.component';
import { RolloverFormComponent } from './components/calculations/rollover/form/rollover-form/rollover-form.component';
import {
  RolloverResultComponent,
} from './components/calculations/rollover/result/rollover-result/rollover-result.component';
import { RrqFormComponent } from './components/calculations/rrq/form/rrq-form/rrq-form.component';
import { RrqResultComponent } from './components/calculations/rrq/result/rrq-result/rrq-result.component';
import { FlagEnum } from '../core/enums/flag.enum';
import { FlagEnabledGuard } from '../core/guards/flag-enabled.guard';
import {
  SalaryDividendFormComponent,
} from './components/calculations/salary-dividend/form/salary-dividend-form/salary-dividend-form.component';
import { OrganizationPermissionEnum } from '../../../../../../common/src/enums/organization-permission.enum';
import {
  SalaryDividendResultComponent,
} from './components/calculations/salary-dividend/result/salary-dividend-result/salary-dividend-result.component';
import { CalculationKeynameEnum } from '../../../../../../common/src/enums/calculations/calculation-keyname.enum';
import {RrspFormComponent} from "./components/calculations/rrsp/form/rrsp-form/rrsp-form.component";
import {RrspResultComponent} from "./components/calculations/rrsp/result/rrsp-result/rrsp-result.component";

export const calculationRoutes: Routes = [{
  path: 'calculations',
  canActivate: [FlagEnabledGuard],
  data: {
    flag: FlagEnum.Calculations,
  },
  children: [
    {
      path: '',
      component: ListCalculationsComponent,
      data: {
        flag: FlagEnum.CalculationsList,
      },
    },
    {
      path: 'create',
      component: CreateNewCalculationComponent,
      data: {
        flag: FlagEnum.CalculationsCreate,
      },
    },
    {
      path: 'SECTION_84_1',
      data: {
        flag: FlagEnum.CalculationsSection84_1,
        organizationPermission: OrganizationPermissionEnum.isSection841Available,
      },
      children: [
        {
          path: ':calculationId',
          component: GetCalculationComponent,
          children: [
            {
              path: '',
              component: Section84_1FormComponent,
              canDeactivate: [CalculationFormEditingGuard],
            },
            {
              path: 'results',
              component: Section84_1ResultComponent,
            },
          ],
        },
      ],
    },
    {
      path: 'ROLLOVER',
      data: {
        flag: FlagEnum.CalculationsRollover,
        organizationPermission: OrganizationPermissionEnum.isRolloverAvailable,
      },
      children: [
        {
          path: ':calculationId',
          component: GetCalculationComponent,
          children: [
            {
              path: '',
              component: RolloverFormComponent,
              canDeactivate: [CalculationFormEditingGuard],
            },
            {
              path: 'results',
              component: RolloverResultComponent,
            },
          ],
        },
      ],
    },
    {
      path: 'RRQ',
      data: {
        flag: FlagEnum.CalculationsRRQ,
        organizationPermission: OrganizationPermissionEnum.isRRQAvailable,
      },
      children: [
        {
          path: ':calculationId',
          component: GetCalculationComponent,
          children: [
            {
              path: '',
              component: RrqFormComponent,
              canDeactivate: [CalculationFormEditingGuard],
            },
            {
              path: 'results',
              component: RrqResultComponent,
            },
          ],
        },
      ],
    },
    {
      path: CalculationKeynameEnum.SalaryDividendSimulation,
      data: {
        flag: FlagEnum.CalculationsSalaryDividend,
        organizationPermission: OrganizationPermissionEnum.isSalaryDividendAvailable,
      },
      children: [
        {
          path: ':calculationId',
          component: GetCalculationComponent,
          children: [
            {
              path: '',
              component: SalaryDividendFormComponent,
              canDeactivate: [CalculationFormEditingGuard],
            },
            {
              path: 'results',
              component: SalaryDividendResultComponent,
            },
          ],
        },
      ],
    },
    {
      path: CalculationKeynameEnum.RrspSimulation,
      data: {
        flag: FlagEnum.CalculationsRrsp,
        organizationPermission: OrganizationPermissionEnum.isRrspAvailable,
      },
      children: [
        {
          path: ':calculationId',
          component: GetCalculationComponent,
          children: [
            {
              path: '',
              component: RrspFormComponent,
              canDeactivate: [CalculationFormEditingGuard],
            },
            {
              path: 'results',
              component: RrspResultComponent,
            },
          ],
        },
      ],
    },
  ],
}];
